import React from 'react'

import ErrorPageHeadingIcon from '../../assets/icons/error-page-heading-icon.svg'
import ButtonBackToPartner from 'components/Buttons/ButtonBackToPartner/ButtonBackToPartner'
import useTextContents from 'common/hooks/useTextContents'
import { BACK_TO_PARTNER_LINK_TYPES } from 'components/Buttons/ButtonBackToPartner/BackToPartnerButtonProps'

import './ErrorPageStyles.scss'

/**
 * Komponent obsługujący stronę błędu aplikacji 
*/
const ErrorPage = (): JSX.Element => {

   const errorPageTextContents = useTextContents()

   return (
      <div className='error-page-outer-wrapper'>
         <img className='error-page-heading-icon' src={ErrorPageHeadingIcon} alt='ooops'/>
         <h1 className='error-page-heading-text'>{errorPageTextContents('errorPage.header')}</h1>
         <div className='error-page-description-text-wrapper'>
            <p>{errorPageTextContents('errorPage.mainContent.part1')}</p>
            <h6>{errorPageTextContents('errorPage.mainContent.part2')}</h6>
         </div>
         <ButtonBackToPartner linkType={BACK_TO_PARTNER_LINK_TYPES.FAILURE} />
      </div>
   )
}

export default ErrorPage